export default function ColorPicker(opts){
    BaseConstructor.call(this)
    let container = opts.container
    let elements = {}
    let context = this
    let current_color = opts.current_color

    this.generate = () =>{
        elements.container = this.createElement('div')
        $(container).append(elements.container)
        createPicker()
    }

    this.update = () =>{

    }

    function createPicker(){
        const pickr = Pickr.create({
            el: elements.container,
            theme: 'nano',
            default: current_color || '',
            components: {
        
                // Main components
                preview: true,
                opacity: false,
                hue: true,
        
                // Input / output Options
                interaction: {
                    hex: true,
                    input: true,
                    clear: false,
                    save: true
                }
            }
        });

        pickr.on('change', (color, source, instance) =>{
            pickr.applyColor(true)
            context.trigger('change', {color: color})
        })
    }
}

ColorPicker.prototype = Object.create(BaseConstructor.prototype)